import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";

const ExcelDownloader = ({ data, fileName = "Report", columns = null, role }) => {
  const handleDownload = () => {
    if (!data || data.length === 0) {
      toast.error("No data available to download");
      return;
    }

    const formattedData = data.map((item) => {
      const base = {
        "Settlement Amount": item.settlementAmount,
        Status: item.status === 1 ? "True" : "False",
        "Settlement Delay": item.settlementDelay === 1 ? "Yes" : "No",
        OrderId: item.orderId,
        UTR: item.utr,
        "Transaction Date": new Date(item.txnDate).toLocaleString("en-GB"),
        "Created At": new Date(item.createdAt).toLocaleString("en-GB"),
      };

      if (role !== "admin") {
        base["Provider Name"] = item.providerName;
      }

      return base;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}_${new Date().toISOString()}.xlsx`);
  };

  return (
    <button className="btn-excel" onClick={handleDownload}>
      Download Report Excel
    </button>
  );
};

export default ExcelDownloader;